<template>
  <div>
  <div id="page" data-swup="0" class="device-is-android">
    <header-bar :title="title" style="overflow:hidden"></header-bar>

    <footer-bar></footer-bar>
    <div
      class="page-content header-clear-medium has-footer-menu"
      style="transform: translateX(0px)"
    >
      <a
        v-for="task in tasks"
        :key="task.id"
        @click="handleDetailModal({ show: true, id: task.id })"
        data-menu="menu-modal-view"
        class="card card-style bg-1"
        data-card-height="220"
        style="height: 220px"
        :style="`background-image:url('${task.defaultAttachmentUrl}?w=820&h=220&mode=pad')`"
      >
        <div class="card-bottom p-3">
          <h1 class="color-white font-20">{{ task.task }}</h1>
        </div>
      </a>
    </div>

    <div class="page-bg">
      <div></div>
    </div>

    <div class="divider divider-margins"></div>
  </div>
</div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";
export default {
  components: {
    footerBar,
    headerBar,
  },
  data() {
    return {
      title:"",
      tasks: {},
    };
  },
  methods: {
    ...mapActions(["handleDetailModal"]),
    init() {
      request({
        api: { method: "POST", url: "taskCore/getCoreList" },
        data: {
          skip: 0,
          size: 10,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: this.$route.params.id,
          },
        },
        store: this.$store,
      }).then((res) => {
        this.tasks = _.sortBy(res.data.tasks, "ord", "asc");
      });

      request({
        api: { method: "get", url: "Type/GetInheritedDetail" },
        params: {
          id: this.$route.params.id,
        },
        store: this.$store,
      }).then((res) => {
        this.title = res.data.name;
      });
    },
  },
  mounted() {
    //alert(this.$route.params.id)
    this.init();
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.id != oldRoute.params.id) {
        this.init();
      }
    },
  },
};
</script>
